import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/AdminShell";
import { AdminImageSearchLab } from "@/components/AdminImageSearchLab";
import { AdminApiQuotas } from "@/components/AdminApiQuotas";

export const Route = createFileRoute("/_authenticated/admin/bildsok")({
  head: () => ({
    meta: [
      { title: "Bildsökslabb — Administration" },
      {
        name: "description",
        content:
          "Internt: kör bildsökningen med Google Lens, Google Vision eller båda och jämför träffarna.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Bildsökslabb — Administration" },
      {
        property: "og:description",
        content: "Jämför bildsökningens varianter och se råa träffar och felmeddelanden.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <AdminShell title="Bildsökslabb">
      <div className="space-y-6">
        <AdminApiQuotas />
        <AdminImageSearchLab />
      </div>
    </AdminShell>
  ),
});
